const ko = {
  // Navbar
  "nav.home": "홈",
  "nav.creators": "크리에이터",
  "nav.campaigns": "캠페인",
  "nav.rewards": "리워드",
  "nav.community": "커뮤니티",
  "nav.pricing": "요금제",
  "nav.registerCreator": "크리에이터 등록",
  "nav.login": "로그인",
  "nav.start": "시작하기",
  "nav.mypage": "마이페이지",
  "nav.settings": "설정",
  "nav.logout": "로그아웃",
  "nav.tokens": "토큰",
  "nav.brands": "브랜드",

  // Hero Section
  "hero.joinCampaign": "캠페인 참여하기",
  "hero.exploreCreators": "크리에이터 탐색",

  // Service Intro
  "service.howItWorks": "How It Works",
  "service.title": "K-POP부터 드라마, 영화, 웹툰까지",
  "service.titleHighlight": "모든 엔터테인먼트 IP 창작 플랫폼",
  "service.desc": "CreatorVerse는 K-POP 아이돌, 드라마 제작사, 영화사, 웹툰 스튜디오의 공식 IP와 AI 기술을 연결해 팬 누구나 창작물을 제작할 수 있는 플랫폼입니다.",
  "service.step.selectIP": "IP 선택",
  "service.step.selectIP.desc": "K-POP, 드라마, 영화, 웹툰 중 원하는 IP를 선택하세요",
  "service.step.joinCampaign": "캠페인 참여",
  "service.step.joinCampaign.desc": "뮤직비디오, 드라마 신, 포스터 등 캠페인을 선택하세요",
  "service.step.aiCreate": "AI로 제작",
  "service.step.aiCreate.desc": "AI 도구로 나만의 창작물을 제작하세요",
  "service.step.shareReward": "공유 & 보상",
  "service.step.shareReward.desc": "커뮤니티에 공유하고 XP를 획득하세요",
  "service.cta.title": "지금 바로 팬 크리에이터가 되세요",
  "service.cta.desc": "K-POP, 드라마, 영화, 웹툰 — 좋아하는 IP로 나만의 창작물을 AI로 만들어보세요",
  "service.cta.startCampaign": "캠페인 시작하기",
  "service.cta.exploreIP": "IP 탐색하기",

  // Latest Campaigns
  "latest.title": "지금 바로 참여할 수 있는",
  "latest.titleHighlight": "최신 엔터테인먼트 캠페인",
  "latest.viewAll": "전체 캠페인",
  "latest.viewAllCampaigns": "모든 캠페인 보기",
  "latest.filter.all": "전체",
  "latest.filter.kpop": "K-POP",
  "latest.filter.drama": "드라마",
  "latest.filter.film": "영화",
  "latest.filter.webtoon": "웹툰",
  "latest.participation": "참여율",
  "latest.participants": "명",

  // Footer
  "footer.platform": "플랫폼",
  "footer.exploreIdols": "아이돌 탐색",
  "footer.campaigns": "캠페인",
  "footer.community": "커뮤니티",
  "footer.pricing": "요금제",
  "footer.createCampaign": "캠페인 만들기",
  "footer.artist": "아티스트",
  "footer.artistRegister": "아티스트 등록",
  "footer.ipManagement": "IP 관리",
  "footer.campaignCreate": "캠페인 출제",
  "footer.fanStats": "팬 통계",
  "footer.support": "고객센터",
  "footer.newsletter": "최신 소식 받기",
  "footer.newsletterDesc": "새로운 캠페인과 아이돌 소식을 받아보세요",
  "footer.emailPlaceholder": "이메일 주소",
  "footer.subscribed": "구독 완료!",
  "footer.startFree": "무료로 시작하기",
  "footer.terms": "이용약관",
  "footer.privacy": "개인정보처리방침",
  "footer.copyright": "© 2026 CreatorVerse. All rights reserved.",

  // Campaigns page
  "campaigns.breadcrumb.home": "홈",
  "campaigns.breadcrumb.campaigns": "캠페인",
  "campaigns.hero.title": "모든 아티스트의",
  "campaigns.hero.titleHighlight": "캠페인 탐험",
  "campaigns.hero.desc": "5명의 아티스트가 제공하는 캠페인에 도전하고 AI 영상을 제작하세요.",
  "campaigns.hero.createVideo": "영상 제작하기",
  "campaigns.filterByArtist": "아티스트별 캠페인",
  "campaigns.all": "전체",
  "campaigns.noResults": "검색 결과가 없습니다",
  "campaigns.resetFilters": "필터 초기화",
  "campaigns.total": "총",
  "campaigns.totalSuffix": "개 캠페인",
  "campaigns.searchPlaceholder": "캠페인 제목으로 검색...",
  "campaigns.allArtists": "전체 아티스트",
  "campaigns.allDifficulty": "전체 난이도",
  "campaigns.difficulty.easy": "입문",
  "campaigns.difficulty.medium": "중급",
  "campaigns.difficulty.hard": "고급",
  "campaigns.sort.latest": "최신순",
  "campaigns.sort.popular": "인기순",
  "campaigns.sort.reward": "보상 높은순",
  "campaigns.sort.deadline": "마감 임박순",
  "campaigns.progress": "진행률",
  "campaigns.participate": "명 참여",
  "campaigns.startCampaign": "캠페인 시작",

  // Login
  "login.title": "로그인",
  "login.welcome": "CreatorVerse에 오신 걸 환영해요!",
  "login.google": "Google로 계속하기",
  "login.kakao": "카카오로 계속하기",
  "login.orEmail": "또는 이메일로 로그인",
  "login.email": "이메일",
  "login.password": "비밀번호",
  "login.forgotPassword": "비밀번호 찾기",
  "login.submit": "로그인",
  "login.loading": "로그인 중...",
  "login.noAccount": "아직 계정이 없으신가요?",
  "login.signup": "회원가입",
  "login.testHint": "테스트: 아무 이메일(@포함) + 8자 이상 비밀번호로 로그인하세요",
  "login.error.default": "로그인에 실패했습니다",

  // Signup
  "signup.step.account": "계정 정보",
  "signup.step.profile": "프로필 설정",
  "signup.accountInfo": "계정 정보 입력",
  "signup.email": "이메일 *",
  "signup.password": "비밀번호 *",
  "signup.passwordConfirm": "비밀번호 확인 *",
  "signup.next": "다음 단계",
  "signup.complete": "가입 완료",
  "signup.hasAccount": "이미 계정이 있으신가요?",
  "signup.login": "로그인",
  "signup.profileSetup": "팬 프로필 설정",
  "signup.nickname": "닉네임 *",
  "signup.nicknamePlaceholder": "커뮤니티에서 사용할 닉네임",
  "signup.favoriteGroup": "최애 그룹 (선택)",
  "signup.agreeTerms": "에 동의합니다 *",
  "signup.agreeMarketing": "마케팅 정보 수신에 동의합니다 (선택)",
  "signup.terms": "이용약관",
  "signup.privacy": "개인정보처리방침",
  "signup.and": " 및 ",
  "signup.done.title": "가입 완료!",
  "signup.done.plan": "플랜으로 시작합니다",
  "signup.done.tokenGranted": "토큰이 지급되었습니다!",
  "signup.done.joinCampaign": "캠페인 참여하기",
  "signup.done.goHome": "홈으로 이동",
  "signup.changePlan": "플랜 변경하기",
  "signup.selectedPlan": "선택한 플랜",
  "signup.tokensPerMonth": "토큰/월",
  "signup.aiUsage": "AI 영상 생성에 사용",

  // Common
  "common.language": "언어",
};

export default ko;
